export default {
  props: { value: Object },
};